<template>
  <v-main>
    <v-container fluid pa-4 pb-12 mb-4>
      <router-view :key="$route.fullPath" v-slot="{ Component }">
        <v-fade-transition hide-on-leave>
          <component :is="Component" />
        </v-fade-transition>
      </router-view>
    </v-container>
  </v-main>
</template>
